import Link from "next/link";

import { Avatar } from "@/features/common/components/Avatar";
import { ModelPersonalInfoFragment } from "@/generated/graphql-hooks";

export const ModelInfoItem = ({
  model,
}: {
  model: ModelPersonalInfoFragment;
}) => {
  return (
    <div className="flex w-max items-center space-x-3">
      <Link
        href={`/kol/${model.id}/${model.username}`}
        passHref
        className="hover:opacity-90"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        <Avatar
          size="lg"
          publicId={model.avatarPublicId}
          name={model.username}
        />
      </Link>
      <div className="space-y-0.5">
        <div className="text-lg font-medium">{model.username}</div>
        <div className="flex flex-col text-sm text-gray-700 sm:flex-row sm:space-x-3">
          <div>
            身高體重 {model.height}cm / {model.weight}
            kg
          </div>
          <div>
            三圍 {model.chest || "-"}
            {model.cupSize} / {model.waist || "-"} / {model.hips || "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
